import React, { useState, useMemo } from 'react';
import { InfoCircle } from 'react-bootstrap-icons';

const tagsLIst = [
  "Business", "Creative", "Calm", "Strict",
  "Technology", "Analytical", "Leadership",
  "Humble", "Design", "Finance", "Science", "Fitness"
];

const MentorSelection = ({ figures, onFigureSelect, onShowInfo, showFigureInfo, onCloseInfo }) => {

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);

  // (Removed the shuffling logic entirely)

  const toggleTag = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(prev => prev.filter(t => t !== tag));
    } else {
      setSelectedTags(prev => [...prev, tag]);
    }
  };

  const filteredFigures = useMemo(() => {
    return figures.filter((figure) => {
      const matchesSearch = figure.name.toLowerCase().includes(searchTerm.toLowerCase());

      if (selectedTags.length === 0) {
        return matchesSearch;
      }

      const matchesTags = selectedTags.every(tag => {
        const lowerTag = tag.toLowerCase();
        
        const lowerField = (figure.expert_field || "").toLowerCase();
        const lowerPersonality = (figure.personality || "").toLowerCase();
        const lowerContext = (figure.expert_context || "").toLowerCase();

        const matchField = lowerField.includes(lowerTag);
        const matchPersonality = lowerPersonality.includes(lowerTag);
        const matchContext = lowerContext.includes(lowerTag);

        return matchField || matchPersonality || matchContext;
      });

      return matchesSearch && matchesTags;
    });
  }, [searchTerm, selectedTags, figures]);

  const chipStyle = (isActive) => ({
    padding: '6px 13px',
    borderRadius: '20px',
    border: isActive ? 'none' : '1px solid #e0e0e0',
    backgroundColor: isActive ? '#8060f6' : '#ffffff',
    color: isActive ? '#fff' : '#495057',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: isActive ? '600' : '400',
    transition: 'all 0.2s ease',
    outline: 'none'
  });

  return (
    <div className="selection-screen fade-in">
        <div className="search-wrapper" style={{ marginBottom: '20px' }}>
            <input
                type="text"
                placeholder="Search mentors..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
                style={{ width: '100%', padding: '12px 20px', borderRadius: '50px', backgroundColor: '#ffffff', color: 'rgb(122, 122, 122)', border: '1px solid #e0e0e0', fontSize: '14px', outline: 'none' }}
            />
        </div>

        <div className="filters-container" style={{ marginBottom: '30px' }}>
            <p style={{ fontSize: '13px', fontWeight: 'bold', color: '#666', marginBottom: '10px', paddingLeft: '5px' }}>
                Filter by Interests & Style:
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {tagsLIst.map(tag => {
                    const isActive = selectedTags.includes(tag);
                    return (
                        <button
                            key={tag}
                            onClick={() => toggleTag(tag)}
                            style={chipStyle(isActive)}
                        >
                            {tag} {isActive && '✕'}
                        </button>
                    );
                })}
            </div>
        </div>

        <div className="options-grid">
            {filteredFigures.length > 0 ? (
                filteredFigures.map((figure) => (
                    <div key={figure.id} className="grid-option-btn" >
                        <button onClick={() => onFigureSelect(figure)}>
                            <div className='figure-card'>
                                <img src={`https://backend.parabyte.media${figure.image}`} alt={figure.name} onError={(e) => {e.target.src = 'https://via.placeholder.com/150'}} />
                                <p className='figure-title mt-3'>{figure.name}</p>
                                <div className='figure-badge-container'>
                                    <span className='figure-badge'>{figure.expert_field}</span>
                                </div>
                                <p className='figure-text-preview'>{figure.personality}</p>
                            </div>
                        </button>
                        <div className='figure-info-container'>
                            <button onClick={() => onShowInfo(figure)} className='figure-info'><InfoCircle /></button>
                        </div>
                    </div>
                ))
            ) : (
                <div className="no-results" style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '40px', color: '#888' }}>
                    <p>No mentors found matching your criteria.</p>
                </div>
            )}
        </div>

        {/* MODAL */}
        {showFigureInfo.personality && (
            <div className='figure-info-overlay' onClick={onCloseInfo}>
                <div className='figure-info-modal' onClick={e => e.stopPropagation()}>
                    <div className='figure-info-card'>
                         {/* Pass FigureInfo component or render content directly */}
                         <div>
                            <h4>Personality</h4>
                            <p>{showFigureInfo.expert_field} - {showFigureInfo.personality}</p>
                         </div>
                    </div>
                </div>
            </div>
        )}
    </div>
  );
};

export default MentorSelection;